import {management} from '../../../index';

export class UpdateSectorNote {
  // Get data needed to build the history of management sector graphic
  async execute(ID_SECTOR, NOTE){
    const raw = `
      UPDATE NEWSIR.CAD_SECTOR CAD_SECTOR
      SET CAD_SECTOR.NOTE = '${NOTE}'
      WHERE CAD_SECTOR.ID = ${ID_SECTOR};
    `;

    const baseResult = await management
      .sql({
        data: {
          sql: raw
        }
      })
      .then(r => r && r[0])

    return baseResult;
  }
}
